<script>
import { resourcesComputed } from '@state/helpers'
import MottoIcon from '@components/motto-icon.vue'
import _ from 'lodash'
import ResourceSearchSuggestion from '@components/search/resource-search-suggestion.vue'
import { searchAutocompleteResources } from '@src/api/resources'
import { transformMany as transformResources } from '@src/api/transformers/resourceTransformer'

export default {
  components: {
    MottoIcon,
    ResourceSearchSuggestion,
  },
  data() {
    return {
      searchQuery: '',
      autocompleteResults: [],
    }
  },
  computed: {
    ...resourcesComputed,
    searchLabel() {
      if (this.shouldSearchByCategory) {
        return `Search Resources in ${_.startCase(this.selectedResourceCategory)}`
      }

      return 'Search Resources'
    },

    shouldSearchByCategory() {
      const isResourceRoute = this.$route.name === 'resources'
      return this.selectedResourceCategory && isResourceRoute
    },
  },

  methods: {
    async search() {
      if (!this.searchQuery) {
        return
      }

      await this.$router.push({
        name: 'search',
        query: {
          query: this.searchQuery,
          category: this.shouldSearchByCategory ? this.selectedResourceCategory : undefined,
        },
      })
    },

    searchForAutocomplete: _.debounce(async function (query) {
      const searchQuery = query?.target?.value
      if (!searchQuery) {
        this.autocompleteResults = []
        return
      }
      try {
        const {
          data: { data: autocompleteResults },
        } = await searchAutocompleteResources({
          query: searchQuery,
          categoryName: this.shouldSearchByCategory ? this.selectedResourceCategory : null,
        })
        this.autocompleteResults = transformResources(autocompleteResults)
      } catch (err) {
        console.warn('There was an error in the autocomplete search. ', err)
      }
    }, 300),
  },
}
</script>

<template>
  <div class="d-flex position-relative">
    <BaseInputText
      v-model="searchQuery"
      class="w-100 h-100"
      name="searchQuery"
      :placeholder="searchLabel"
      @keyup.enter="search"
      @input="searchForAutocomplete" />
    <MottoIcon :class="$style.searchIcon" name="Search" @click.native="search"></MottoIcon>
    <ResourceSearchSuggestion :class="$style.searchSuggestions" :resources="autocompleteResults" />
  </div>
</template>

<style lang="scss" module>
@import '@design';

.searchIcon {
  margin: auto 0 auto -40px;
  cursor: pointer;
}

.searchSuggestions {
  position: absolute;
  top: 48px;
  width: 100%;
}
</style>
